import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosPesajeService,
  ProcedimientoVeterinarioItem,
} from "../../../../../generated/grpc/catalogos_pesaje_pb";

/** Variante gRPC-Web (con delta) de `ProcedimientoVeterinarioGetCatalogService` (ver ese archivo). */
export class ProcedimientoVeterinarioGrpcCatalogService extends BaseGrpcCatalogService<ProcedimientoVeterinarioItem> {
  protected readonly storeName = "procedimientosVeterinarios" as const;
  protected readonly sortFieldName = "nombre";

  protected async fetchAsync(ultimaSincronizacion: bigint): Promise<GrpcCatalogoFetchResult<ProcedimientoVeterinarioItem>> {
    const client = createClient(CatalogosPesajeService, grpcTransportProvider.get());

    try {
      const response = await client.listProcedimientoVeterinarios({ ultimaSincronizacion });
      return { items: response.items, timestampSincronizacion: response.timestampSincronizacion };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de procedimientos veterinarios. */
export const procedimientoVeterinarioGrpcCatalogService = new ProcedimientoVeterinarioGrpcCatalogService();
